import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import Button from "../../../../components/ui/Button";
import Text from "../../../../components/ui/Text";

export const LeaveGameConfirmationDialog = ({
  isOpen,
  onClose,
  onSubmit,
  gameDetails,
}) => {
  const { datetime } = gameDetails;

  // Check if there's less than 8 hours until the game
  const now = Date.now();
  const timeUntilGame = datetime - now;
  const hoursUntilGame = timeUntilGame / (1000 * 60 * 60);
  const isLessThan8Hours = hoursUntilGame < 8;

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      slotProps={{
        paper: { sx: { borderRadius: "12px", m: 2, width: "310px" } },
      }}
    >
      <DialogTitle sx={{ p: 3, pb: 1 }}>
        <Text variant="pageHeader" sx={{ mb: 0, fontSize: "20px" }}>
          Are you sure you want to leave?
        </Text>
      </DialogTitle>

      <DialogContent sx={{ px: 3, py: 2 }}>
        <Text variant="paragraph" sx={{ fontSize: "16px" }}>
          {isLessThan8Hours ? (
            <>
              You will not be refunded because you are leaving within 8 hours of
              the kick off time.
            </>
          ) : (
            <>
              You will receive a full refund in game credits that you can use
              towards the next game
            </>
          )}
        </Text>
      </DialogContent>

      <DialogActions
        sx={{
          p: 3,
          pt: 1,
          gap: 2,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Button
          variant="primary"
          onClick={onSubmit}
          sx={{
            flex: 1,
            fontSize: "16px",
          }}
        >
          Yes, leave game
        </Button>
        <Button
          variant="secondary"
          onClick={onClose}
          sx={{ flex: 1, fontSize: "16px" }}
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};
